<header style="background: #000219; font-size: 14px;" class="text-white top-contact-bar">
    <div class="container-fluid top-contact-bar-inner">

        <ul class="list-unstyled d-flex flex-wrap align-items-center mb-0 top-contact-left">
            <li class="d-flex align-items-center me-md-4 mb-2 mb-md-0">
                <i class="fa fa-phone me-2"></i>
                <a href="tel:+27115685421" class="text-decoration-none text-white">
                    (+27) 11 568 5421
                </a>
            </li>

            <li class="d-flex align-items-center mb-2 mb-md-0">
                <i class="fa fa-envelope me-2"></i>
                <a href="mailto:mufk@dotblack.co.za" class="text-decoration-none text-white">
                    mufk@dotblack.co.za
                </a>
            </li>
        </ul>

        <ul class="list-unstyled d-flex flex-wrap align-items-center mb-0 top-contact-right">
            <li class="d-flex align-items-center mb-2 mb-md-0">
                <a routerLink="/about-us" routerLinkActive="active" class="text-decoration-none text-white top-link" (click)="closeNavbar()">
                    About Us
                </a>
            </li>
        </ul>

    </div>
</header>

<div class="container-fluid">
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <div class="logo">
            <img
                routerLink="/"
                (click)="closeNavbar()"
                style="height: 100px; width: 200px;"
                src="/assets/img/dotBlackLogo-removebg-preview.png"
                alt="DotBlack"
            />
        </div>

        <button
            class="navbar-toggler me-4 me-sm-0"
            type="button"
            (click)="toggleClass()"
            [class.active]="classApplied"
            [attr.aria-expanded]="classApplied"
            aria-controls="navbarSupportedContent"
            aria-label="Toggle navigation"
        >
            <span class="toggler-line"></span>
            <span class="toggler-line"></span>
            <span class="toggler-line"></span>
        </button>

        <div
            id="navbarSupportedContent"
            class="collapse navbar-collapse"
            [class.show]="classApplied"
        >
            <ul class="navbar-nav m-auto ps-4 ps-lg-0">

                <li class="nav-item">
                    <a
                        routerLink="/"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        class="nav-link"
                        (click)="closeNavbar()"
                    >
                        Home
                    </a>
                </li>

                <li class="nav-item hide-on-desktop">
                    <a
                        routerLink="/about-us"
                        routerLinkActive="active"
                        class="nav-link"
                        (click)="closeNavbar()"
                    >
                        About Us
                    </a>
                </li>

                <li class="nav-item">
                    <a
                        routerLink="/digital-solutions"
                        routerLinkActive="active"
                        class="nav-link"
                        (click)="closeNavbar()"
                    >
                        Digital Solutions
                    </a>
                </li>

                <li class="nav-item">
                    <a
                        routerLink="/it-consulting"
                        routerLinkActive="active"
                        class="nav-link"
                        (click)="closeNavbar()"
                    >
                        IT Consulting
                    </a>
                </li>

                <li class="nav-item">
                    <a
                        routerLink="/rpa"
                        routerLinkActive="active"
                        class="nav-link"
                        (click)="closeNavbar()"
                    >
                        RPA
                    </a>
                </li>

                <li class="nav-item">
                    <a
                        routerLink="/project-management"
                        routerLinkActive="active"
                        class="nav-link"
                        (click)="closeNavbar()"
                    >
                        Project Management
                    </a>
                </li>

                <li class="nav-item">
                    <a
                        routerLink="/it-services"
                        routerLinkActive="active"
                        class="nav-link"
                        (click)="closeNavbar()"
                    >
                        IT Resource Augmentation
                    </a>
                </li>

                <li class="nav-item hide-on-desktop">
                    <a
                        routerLink="/contact"
                        routerLinkActive="active"
                        class="nav-link"
                        (click)="closeNavbar()"
                    >
                        Contact Us
                    </a>
                </li>

            </ul>

            <div class="others-option ps-4 ps-sm-0 pt-4 pt-sm-0 hide-on-mobile">
                <div class="d-flex align-items-center">
                    <div class="option-item">
                        <a
                            style="text-decoration: none; color: white !important;"
                            routerLink="/contact"
                            class="default-btn"
                            (click)="closeNavbar()"
                        >
                            Contact Us
                            <span></span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</div>